import FavIcon from 'material-ui-icons/Favorite'
import Grid from 'material-ui/Grid'
import List from 'material-ui/List'
import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import { put } from '../../modules/Api'
import styleSheet from './AllWebChatStyle.style'
import WebChatStaffReview from './WebChatStaffReview'

import { ListItem, ListItemText, Typography } from 'material-ui'
import moment from 'moment'
import images from '../common/images'

const CLINTAL_BLUE = '#5A8DDA'

class WebChatChat extends React.Component {
  state = {
    review: [],
  }

  componentWillReceiveProps(nextProps) {
    const review = [...this.state.review]
    // 直接reverseすると、props.chatsの中身も変わってしまうのでslice()でコピーを作成している
    nextProps.chats
      .slice()
      .reverse()
      .map((chat) => {
        const { staff_chat_review } = chat.attributes

        if (staff_chat_review != null) {
          const { review_score, review_message } = staff_chat_review
          const already_submit = review_score != 0 ? true : false
          review.unshift({ review_score, review_message, already_submit })
        }
      })
    this.setState({ review })
  }

  setReviewState(attr_name, value, review_number) {
    const review_copy = this.state.review.slice()
    review_copy[review_number][`${attr_name}`] = value
    this.setState({ review: review_copy })
  }

  submitReview(review_id, review_number) {
    const { review_message, review_score } = this.state.review[review_number]
    put(
      '/api/web_chat/staff_chat_review/update',
      { attributes: { review_message, review_score, review_id } },
      (response) => {
        const review_copy = this.state.review.slice()
        review_copy[review_number].already_submit = true
        this.setState({ review: review_copy })
      }
    )
  }

  addLinkToMessage(message) {
    const internal_url = 'https://clintal.com/premium'
    const external_url = 'https://www.iryou.teikyouseido.mhlw.go.jp/znk-web/'

    let url = ''
    let linkName = ''
    let linkIndex = -1

    if (message.match(internal_url)) {
      url = internal_url
      linkName = '医師紹介サービストップページ'
      linkIndex = message.indexOf(internal_url)
    }
    if (message.match(external_url)) {
      url = external_url
      linkName = '厚生労働省 医療情報ネット(ナビイ)'
      linkIndex = message.indexOf(external_url)
    }

    if (linkIndex !== -1) {
      let beforeNonLinkPart = ''
      if (linkIndex !== 0) {
        beforeNonLinkPart = message.slice(0, linkIndex)
      }

      const afterNonLinkPart = message.slice(linkIndex + url.length)

      const link = (
        <a key={url} href={url} target="_blank" rel="noopener noreferrer">
          {linkName}
        </a>
      )
      return [beforeNonLinkPart, link, afterNonLinkPart]
    }

    return message
  }

  render() {
    const { chats, classes } = this.props
    const { review } = this.state
    let chat_date
    let before_chat_date
    let counter = 0
    let clinic_doctors = []
    let hospitals = []

    return (
      <div>
        <List>
          {chats &&
            chats.map((chatChat, index) => {
              if (chatChat.attributes.suggestions) {
                if (chatChat.attributes.suggestions.clinic_doctor != null) {
                  clinic_doctors = chatChat.attributes.suggestions.clinic_doctor
                }
                if (chatChat.attributes.suggestions.hospitals) {
                  if (chatChat.attributes.suggestions.hospitals != null) {
                    hospitals = chatChat.attributes.suggestions.hospitals
                  }
                }
              }
              const createdAt = moment(chatChat.attributes.created_at).format('HH:mm')
              const flag_read = chatChat.attributes.flag_read ? '既読' : '未読'
              const like_btn_color = chatChat.attributes.like ? classes.textRed : classes.textGray
              const senderTypeStaffOrBot =
                chatChat.attributes.sender_type === 1 || chatChat.attributes.sender_type === 2
              if (chat_date != before_chat_date) {
                before_chat_date = chat_date
              }
              chat_date = moment(chatChat.attributes.created_at).format('YYYY年MM月DD日')
              // スタッフのチャットを評価するフォーム
              if (review.length && chatChat.attributes && chatChat.attributes.staff_chat_review) {
                const review_number = counter
                const already_submit = review[review_number].already_submit
                const submit_review = already_submit ? classes.chat_cannotSendReview : classes.chat_reviewSend
                counter++

                return (
                  <ListItem key={`${index}-${chatChat.id}`}>
                    <WebChatStaffReview
                      submitReview={(review_id, review_number) => this.submitReview(review_id, review_number)}
                      setReviewState={(attr_name, value, review_number) =>
                        this.setReviewState(attr_name, value, review_number)
                      }
                      review={review}
                      submit_review={submit_review}
                      review_number={review_number}
                      review_id={chatChat.attributes.staff_chat_review.id}
                      createdAt={createdAt}
                      already_submit={already_submit}
                      message={chatChat.attributes.message}
                    />
                  </ListItem>
                )
              }

              return (
                <ListItem key={`${index}-${chatChat.id}`}>
                  {
                    senderTypeStaffOrBot ?
                      !chatChat.attributes.suggestions ?
                        // ナースかBOTの発言
                        <Grid container spacing={0}>
                          {chat_date != before_chat_date && (
                            <Grid item xs={12} className={classes.chat_submitDate}>
                              <p className="text-center">
                                <b>{chat_date}</b>
                              </p>
                            </Grid>
                          )}

                          <Grid item xs={1} className={classes.chat_nurseImg}>
                            <img
                              src={chatChat.attributes.flag_staff_talking ? images.icNurse : images.icBot}
                              width={30}
                              height={30}
                            />
                          </Grid>

                          <Grid item xs={11} className={classes.chat_nurseContent}>
                            <div className={classes.chat_chatBox}>
                              <div className={classes.chat_nurseChatTail}></div>
                              <div className={classes.chat_nurseChatTailSub}></div>

                              {chatChat && chatChat.attributes && chatChat.attributes.chat_images.length >= 1 ?
                                // 添付画像の表示
                                <img
                                  src={chatChat.attributes.chat_images[0].large_thumbnail_url}
                                  width={100}
                                  height={100}
                                />
                              : <ListItemText
                                  primary={
                                    <Typography
                                      type="caption"
                                      className={classes.textBlack}
                                      style={{ whiteSpace: 'pre-wrap' }}
                                    >
                                      {this.addLinkToMessage(
                                        chatChat && chatChat.attributes && chatChat.attributes.message
                                      )}
                                    </Typography>
                                  }
                                  className={classes.chat_nurseChat}
                                />
                              }

                              {chatChat.attributes.staff_id != null && (
                                <div className={classes.like_btn_circle}>
                                  <FavIcon
                                    className={`${like_btn_color} ${classes.like_btn_heart}`}
                                    onClick={() => {
                                      this.props.clickLikeButton(
                                        chatChat.attributes.seq_num,
                                        chatChat.attributes.like,
                                        index
                                      )
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                            <Typography type="caption" className={classes.chat_createdAt}>
                              {createdAt}
                            </Typography>
                          </Grid>
                        </Grid>
                        // 病院の紹介
                      : clinic_doctors ?
                        <Grid container spacing={0}>
                          <Grid item xs={12} className={classes.chat_hospitalContent}>
                            {clinic_doctors.map((doctor) => {
                              let clinicDoctors = (
                                <a href={`/clinic/${doctor.id}`}>
                                  <div
                                    key={doctor.id}
                                    className={classes.chat_hospitalIntro}
                                    style={{ display: 'inlineBlock' }}
                                  >
                                    <div className={classes.chat_hospitalInfo}>
                                      <div className={classes.chat_flex02}>
                                        <img src={images.icHospital} width={40} height={40} />
                                      </div>
                                      <div className={classes.chat_flex8}>
                                        <div>{doctor.hospitals.name}</div>
                                        <div className={classes.textBlue} style={{ fontSize: 17 }}>
                                          {doctor.name}
                                        </div>
                                      </div>
                                    </div>
                                    <div className={classes.chat_hospitalBorder}></div>
                                    <div className={classes.chat_hospitalBox}>
                                      <div className={classes.chat_hospitalDoctor}>
                                        <div>
                                          <img src={images.icTell} width={20} height={20} />
                                        </div>
                                        <div style={{ marginLeft: 5 }}>{doctor.hospitals.tel}</div>
                                      </div>
                                      <div className={classes.chat_hospitalAddress}>
                                        <div>
                                          <img src={images.icMap} width={15} height={20} />
                                        </div>
                                        <div style={{ marginLeft: 5 }}>
                                          <span style={{ wordWrap: 'breakWord' }}>{doctor.hospitals.address}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              )
                              return clinicDoctors
                            })}

                            {(clinic_doctors = undefined)}
                          </Grid>
                        </Grid>
                      : <Grid container spacing={0}>
                          <Grid item xs={12} className={classes.chat_hospitalContent}>
                            {hospitals.map((hospital) => {
                              let hospitals = (
                                <div
                                  key={hospital.id}
                                  className={classes.chat_hospitalIntro}
                                  style={{ display: 'inlineBlock' }}
                                >
                                  <div className={classes.chat_hospitalInfo}>
                                    <div className={classes.chat_flex02}>
                                      <img src={images.icHospital} width={40} height={40} />
                                    </div>
                                    <div className={classes.chat_flex8}>
                                      <div className={classes.textBlue} style={{ fontSize: 17 }}>
                                        {hospital.name}
                                      </div>
                                    </div>
                                  </div>
                                  <div className={classes.chat_hospitalBorder}></div>
                                  <div className={classes.chat_hospitalBox}>
                                    <div className={classes.chat_hospitalDoctor}>
                                      <div>
                                        <img src={images.icTell} width={20} height={20} />
                                      </div>
                                      <div style={{ marginLeft: 5 }}>{hospital.tel}</div>
                                    </div>
                                    <div className={classes.chat_hospitalAddress}>
                                      <div>
                                        <img src={images.icMap} width={15} height={20} />
                                      </div>
                                      <div style={{ marginLeft: 5 }}>
                                        <span style={{ wordWrap: 'breakWord' }}>{hospital.address}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                              return hospitals
                            })}

                            {(hospitals = undefined)}
                          </Grid>
                        </Grid>

                      // ユーザーの発言
                    : <Grid container spacing={0}>
                        {chat_date != before_chat_date && (
                          <Grid item xs={12} className={classes.chat_submitDate}>
                            <p className="text-center">
                              <b>{chat_date}</b>
                            </p>
                          </Grid>
                        )}

                        <Grid item xs={12} className={classes.chat_userContent}>
                          <Typography type="caption" className={classes.chat_flag}>
                            {flag_read}
                            <br />
                            {createdAt}
                          </Typography>
                          <div className={classes.chat_chatBox}>
                            {chatChat && chatChat.attributes && chatChat.attributes.chat_images.length >= 1 ?
                              <img src={chatChat.attributes.chat_images[0].large_thumbnail_url} width={100} />
                            : <div>
                                <div className={classes.chat_userChatTail}></div>
                                <div className={classes.chat_userChatTailSub}></div>
                                <ListItemText
                                  primary={
                                    <Typography type="caption" className={classes.textWhite}>
                                      {chatChat && chatChat.attributes && chatChat.attributes.message}
                                    </Typography>
                                  }
                                  className={classes.chat_userChat}
                                />
                              </div>
                            }
                          </div>
                        </Grid>
                      </Grid>

                  }
                </ListItem>
              )
            })}
        </List>
      </div>
    )
  }
}

export default withStyles(styleSheet)(WebChatChat)
